import {
  Avatar,
  AvatarColorScheme
} from '@amzn/stencil-react-components/avatar';
import { Row, Spacer } from '@amzn/stencil-react-components/layout';
import {
  PageHeader,
  PageHeaderLink
} from '@amzn/stencil-react-components/page';
import { Text } from '@amzn/stencil-react-components/text';
import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { UserContext } from 'src/components/Authentication/Authentication';
import PxtCmsLogo from 'src/components/NavigationBar/PxtCmsLogo';
import { PHONE_TOOL } from 'src/constants/DisplayConstants';
import { PAGE_PATHS } from 'src/constants/Urls';
import { LEGAL_REPORT_ALLOW_LIST } from 'src/constants/UserAllowlistConstants';
import { hasAccessPermission } from 'src/utils/commons/CommonUtils';
import './NavigationBar.scss';

// PageHeaderLink rendered as a router NavLink so the current section is
// highlighted (active underline) and clicking navigates client-side.
const PageHeaderNavLink = PageHeaderLink.withComponent(NavLink);

const NavigationBar = () => {
  const authenticatedUser = useContext(UserContext).authenticatedUser;
  const fullName =
    authenticatedUser.firstName + ' ' + authenticatedUser.lastName;

  const canViewLegalReports = hasAccessPermission(
    authenticatedUser.employeeId,
    LEGAL_REPORT_ALLOW_LIST
  );

  return (
    <PageHeader>
      <nav style={{ display: 'flex', flex: 1 }}>
        <Row height="100%" width="100%" alignItems="center" gridGap="S400">
          <PageHeaderNavLink to="/" exact>
            <Row alignItems="center" gridGap="S200">
              <PxtCmsLogo size={30} />
              <Text fontSize="T400" fontWeight="bold">
                PXT CMS Admin Console
              </Text>
            </Row>
          </PageHeaderNavLink>

          <Row height="100%" alignItems="center" gridGap="S200">
            <PageHeaderNavLink
              to={PAGE_PATHS.DOMAINS}
              className={'header-nav-link'}
              activeClassName={'header-nav-link--active'}
            >
              Domain Configurations
            </PageHeaderNavLink>
            {canViewLegalReports && (
              <PageHeaderNavLink
                to={PAGE_PATHS.LEGAL_REPORTS}
                className={'header-nav-link'}
                activeClassName={'header-nav-link--active'}
              >
                Legal Reports
              </PageHeaderNavLink>
            )}
          </Row>

          <Spacer flex={1} />
          <PageHeaderLink
            key={'user-avatar'}
            hasHover={false}
            href={PHONE_TOOL + `${authenticatedUser.alias}`}
            target="_blank"
          >
            <Avatar
              isUsernameClickable={false}
              colorScheme={AvatarColorScheme.Inverted}
              fullName={fullName}
              username={authenticatedUser.alias}
              showUsername={false}
            />
          </PageHeaderLink>
        </Row>
      </nav>
    </PageHeader>
  );
};

export default NavigationBar;
